// Libs
import React from 'react'

// CSS
import "./styles.scss"

const SpCasePageMoreInfoComments = ({
  title,
  options,
  value,
  placeholder,
  handleChange,
  handleBlur
}) => {
  return (
    <div className="my-cases-page-filter-comments">
      <p>{title}</p>
      <textarea value={value ? value : ''} placeholder={placeholder} onChange={handleChange} onBlur={handleBlur} />
    </div>
  )
}

export default SpCasePageMoreInfoComments
